var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.570312,
    y: 0.570068,
    width: 86.86,
    height: 86.86,
    rx: 43.43,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.001 30.4143C46.5846 30.4143 48.6781 32.5078 48.6781 35.0913C48.6781 37.6749 46.5846 39.7684 44.001 39.7684C41.4175 39.7684 39.324 37.6749 39.324 35.0913C39.324 32.5078 41.4175 30.4143 44.001 30.4143ZM44.001 50.4589C50.6158 50.4589 57.5868 53.7106 57.5868 55.136V57.5858H30.4152V55.136C30.4152 53.7106 37.3863 50.4589 44.001 50.4589ZM44.001 26.1826C39.079 26.1826 35.0923 30.1693 35.0923 35.0913C35.0923 40.0134 39.079 44.0001 44.001 44.0001C48.9231 44.0001 52.9097 40.0134 52.9097 35.0913C52.9097 30.1693 48.9231 26.1826 44.001 26.1826ZM44.001 46.2272C38.0545 46.2272 26.1836 49.2117 26.1836 55.1359V59.5903C26.1836 60.8153 27.1858 61.8175 28.4108 61.8175H59.5913C60.8162 61.8175 61.8185 60.8153 61.8185 59.5903V55.1359C61.8185 49.2117 49.9476 46.2272 44.001 46.2272Z",
    fill: "#D5D5D5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEmpty);
export default __webpack_public_path__ + "static/media/avatar-empty.ce8095b5c4b6f0d1c20bf958a13d195f.svg";
export { ForwardRef as ReactComponent };